import Vue from 'vue'
import Vuex from 'vuex'
import user from '@store/modules/user'
import loader from '@store/modules/loader'
import pedido from '@store/modules/pedido'
import popup from '@store/modules/popup'
import modal from '@store/modules/modal'
import ctacte from '@store/modules/ctacte'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  modules: {
    user,
    loader,
    pedido,
    popup,
    modal,
    ctacte
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js